import PageLoader from "../../components/common/pageLoader/PageLoader";
import PermissionListWrapper from "./PermissionWrapper";

const SecurityPermissionList = (props) => {

  const { setIsLoad, onPermissionSet, permissionTreeData } = props;

  const onUpdatePermission = (data) => {
    onPermissionSet && onPermissionSet(data);
  };

  return (
    <div className="tree-section-view">
      <div className="section-header-part mt-2">
        <div className="security-key">Security Key</div>
        <div className="permission-dropdown">Permission Type</div>
      </div>
      <div className="inner-section">
        {!setIsLoad ?
          <PermissionListWrapper
            treeData={permissionTreeData}
            level={0}
            onTreeNodeDataChange={onUpdatePermission}
          />
          : <PageLoader />}

      </div>
    </div>
  );
};
export default SecurityPermissionList;
